function totalSavings(){
    /* length and width calculcation */
    var width = document.getElementById("width").value;
    var length = document.getElementById("length").value;
    var slabsize = (length * width);
    var sl62 = (slabsize / 1.34);
    var sl72 = (slabsize / 1.34);
    var sl82 = (slabsize / 1.2);
    var sl92 = (slabsize / 1.07);
	/*var length = document.getElementById("length").value;
	var width = document.getElementById("width").value;
    var sl72 = ((length * width) / 1.34);
    var sl82 = ((length * width) / 1.2);
    var sl92 = ((length * width) / 1.07);*/

  /* User pricing input */
  var sl62price = document.getElementById("sl62pricing").value;
   if (sl62price <= 0) {
  	 var sl62price = document.getElementById("sl62pricing").innerHTML = Number("80");
   } else {
     document.getElementById("sl62price").innerHTML = Number((Math.round(sl62price))).toLocaleString();
   }

   var sl72price = document.getElementById("sl72pricing").value;
   if (sl72price <= 0) {
  	 var sl72price = document.getElementById("sl72pricing").innerHTML = Number("100");
   } else {
     document.getElementById("sl72price").innerHTML = Number((Math.round(sl72price))).toLocaleString();
   }

   var sl82price = document.getElementById("sl82pricing").value;
   if (sl82price <= 0) {
  	 var sl82price = document.getElementById("sl82pricing").innerHTML = Number("130");
   } else {
     document.getElementById("sl82price").innerHTML = Number((Math.round(sl82price))).toLocaleString();
   }

   var sl92price = document.getElementById("sl92pricing").value;
   if (sl92price <= 0) {
  	 var sl92price = document.getElementById("sl92pricing").innerHTML = Number("150");
   } else {
     document.getElementById("sl92price").innerHTML = Number((Math.round(sl92price))).toLocaleString();
   }

  /* User pricing output*/

  if (sl62price <= 0) {
    document.getElementById("sl62price").innerHTML = Number("80");
  } else {
    document.getElementById("sl62price").innerHTML = Number((Math.round(sl62price))).toLocaleString();
  }

  if (sl72price <= 0) {
    document.getElementById("sl72price").innerHTML = Number("100");
  } else {
    document.getElementById("sl72price").innerHTML = Number((Math.round(sl72price))).toLocaleString();
  }

  if (sl82price <= 0) {
    document.getElementById("sl82price").innerHTML = Number("130");
  } else {
    document.getElementById("sl82price").innerHTML = Number((Math.round(sl82price))).toLocaleString();
  }

  if (sl92price <= 0) {
    document.getElementById("sl92price").innerHTML = Number("150");
  } else {
    document.getElementById("sl92price").innerHTML = Number((Math.round(sl92price))).toLocaleString();
  }

    /* Calculations */

    var sqm = (slabsize);
    document.getElementById("sqm").innerHTML = Number((Math.round(sqm))).toLocaleString();
    document.getElementById("sl62").innerHTML = Number((Math.round(sl62))).toLocaleString();
	  document.getElementById("sl72").innerHTML = Number((Math.round(sl72))).toLocaleString();
    document.getElementById("sl82").innerHTML = Number((Math.round(sl82))).toLocaleString();
    document.getElementById("sl92").innerHTML = Number((Math.round(sl92))).toLocaleString();
    var sl62sheets = (sqm / 12.4);
    document.getElementById("sl62sheets").innerHTML = Number((Math.round(sl62sheets))).toLocaleString();
    var sl72sheets = (sqm / 12.4);
    document.getElementById("sl72sheets").innerHTML = Number((Math.round(sl72sheets))).toLocaleString();
    var sl82sheets = (sqm / 12.4);
    document.getElementById("sl82sheets").innerHTML = Number((Math.round(sl82sheets))).toLocaleString();
    var sl92sheets = (sqm / 12.4);
    document.getElementById("sl92sheets").innerHTML = Number((Math.round(sl92sheets))).toLocaleString();
    
    /* savings */
    
    var sl62savings = (sl62sheets * sl62price) - (sl62 * 6.50);
    document.getElementById("sl62savings").innerHTML = Number((Math.round(sl62savings))).toLocaleString();
    var sl72savings = (sl72sheets * sl72price) - (sl72 * 6.50);
    document.getElementById("sl72savings").innerHTML = Number((Math.round(sl72savings))).toLocaleString();
    var sl82savings = (sl82sheets * sl82price) - (sl82 * 6.50);
    document.getElementById("sl82savings").innerHTML = Number((Math.round(sl82savings))).toLocaleString();
    var sl92savings = (sl92sheets * sl92price) - (sl92 * 6.50);
    document.getElementById("sl92savings").innerHTML = Number((Math.round(sl92savings))).toLocaleString();
    var sl62kg = (sl62sheets * 33);
    var sl62gfrp = (sl62kg / 4);
    var sl72kg = (sl72sheets * 41);
    /*document.getElementById("sl72kg").innerHTML = Number((Math.round(sl72kg))).toLocaleString();*/
    var sl82kg = (sl82sheets * 52);
   /* document.getElementById("sl82kg").innerHTML = Number((Math.round(sl82kg))).toLocaleString();*/
    var sl92kg = (sl92sheets * 65);
   /* document.getElementById("sl92kg").innerHTML = Number((Math.round(sl92kg))).toLocaleString();*/
    var sl72gfrp = (sl72kg / 4);
    /* document.getElementById("sl72gfrp").innerHTML = Number((Math.round(sl72gfrp))).toLocaleString();*/
    var sl82gfrp = (sl82kg / 4);
   /*  document.getElementById("sl82gfrp").innerHTML = Number((Math.round(sl82gfrp))).toLocaleString();*/
    var sl92gfrp = (sl92kg / 4);
   /*  document.getElementById("sl92gfrp").innerHTML = Number((Math.round(sl92gfrp))).toLocaleString();*/
    var weightsaved62 = (sl62kg - sl62gfrp);
    document.getElementById("weightsaved62").innerHTML = Number((Math.round(weightsaved62))).toLocaleString(); 
    var weightsaved72 = (sl72kg - sl72gfrp);
    document.getElementById("weightsaved72").innerHTML = Number((Math.round(weightsaved72))).toLocaleString();
    var weightsaved82 = (sl82kg - sl82gfrp);
    document.getElementById("weightsaved82").innerHTML = Number((Math.round(weightsaved82))).toLocaleString();
    var weightsaved92 = (sl92kg - sl92gfrp);
    document.getElementById("weightsaved92").innerHTML = Number((Math.round(weightsaved92))).toLocaleString();

  /* sl62 Cost per m2 Calculations */

    var sl62totalcosts = ((sl62sheets * sl62price) / sqm);
    document.getElementById("sl62totalcosts").innerHTML = sl62totalcosts.toPrecision(3);

    var sl62gfrptotalcosts = ((sl62 * 6.50) / sqm);
    document.getElementById("sl62gfrptotalcosts").innerHTML = sl62gfrptotalcosts.toPrecision(3);

    var sl62percentage = (100 - ((sl62gfrptotalcosts / sl62totalcosts) * 100));
    document.getElementById("sl62percentage").innerHTML = sl62percentage.toPrecision(3);

   /* sl72 Cost per m2 Calculations */

    var sl72totalcosts = ((sl72sheets * sl72price) / sqm);
    document.getElementById("sl72totalcosts").innerHTML = sl72totalcosts.toPrecision(3);

    var sl72gfrptotalcosts = ((sl72 * 6.50) / sqm);
    document.getElementById("sl72gfrptotalcosts").innerHTML = sl72gfrptotalcosts.toPrecision(3);

    var sl72percentage = (100 - ((sl72gfrptotalcosts / sl72totalcosts) * 100));
    document.getElementById("sl72percentage").innerHTML = sl72percentage.toPrecision(3);

    /* sl82 Cost per m2 Calculations */

  	var sl82totalcosts = ((sl82sheets * sl82price) / sqm);
    document.getElementById("sl82totalcosts").innerHTML = sl82totalcosts.toPrecision(3);

    var sl82gfrptotalcosts = ((sl82 * 6.50) / sqm);
    document.getElementById("sl82gfrptotalcosts").innerHTML = sl82gfrptotalcosts.toPrecision(3);

    var sl82percentage = (100 - ((sl82gfrptotalcosts / sl82totalcosts) * 100));
    document.getElementById("sl82percentage").innerHTML = sl82percentage.toPrecision(3);
  
    /* sl92 Cost per m2 Calculations */

  	var sl92totalcosts = ((sl92sheets * sl92price) / sqm);
    document.getElementById("sl92totalcosts").innerHTML = sl92totalcosts.toPrecision(3);

    var sl92gfrptotalcosts = ((sl92 * 6.50) / sqm);
    document.getElementById("sl92gfrptotalcosts").innerHTML = sl92gfrptotalcosts.toPrecision(3);

    var sl92percentage = (100 - ((sl92gfrptotalcosts / sl92totalcosts) * 100));
    document.getElementById("sl92percentage").innerHTML = sl92percentage.toPrecision(3);

}